import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Alert, Button, CircularProgress } from "@mui/material";
import { toast } from "react-toastify";
import { api } from "../../../services/api";
import useEventoStore from "../../../stores/useEventoStore";
import EditorPublicacion from "../../../components/publicacion/EditorPublicacion";
import { fromPublicacion } from "../../../domain/publicacion/payload";

/* Edición de una publicación: /publicaciones/:id/editar */
const EditPublicacion = () => {
  const { id } = useParams();
  const history = useHistory();
  const [valores, setValores] = useState(null);
  const [eventoId, setEventoId] = useState(null);
  const [evento, setEvento] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelado = false;
    api.publicaciones.get(id)
      .then(async (response) => {
        if (cancelado) return;
        if (response.status !== "success") {
          setError(response.message || "No se pudo cargar la publicación.");
          return;
        }
        const pub = response.data.publicacion;
        setValores(fromPublicacion(pub));
        setEventoId(pub.idevento);
        const data = await useEventoStore.getState().fetchEvento(pub.idevento);
        if (!cancelado) setEvento(data?.evento ?? null);
      })
      .catch(() => !cancelado && setError("No se pudo conectar con el servidor."));
    return () => { cancelado = true; };
  }, [id]);

  const guardar = async (payload) => {
    try {
      const response = await api.publicaciones.updatePublicacion(payload);
      if (response.status !== "success") {
        toast.error(response.message || "No se pudo guardar la publicación.");
        return;
      }
      toast.success("Los cambios se guardaron correctamente.");
    } catch (err) {
      toast.error("No se pudo conectar con el servidor.");
    }
  };

  if (error) return <Alert severity="error" sx={{ m: 3 }}>{error}</Alert>;
  if (!valores) {
    return (
      <div className="d-flex justify-content-center p-5">
        <CircularProgress />
      </div>
    );
  }

  return (
    <div className="d-flex justify-content-center px-2 mt-4 mb-5">
      <div style={{ maxWidth: "700px", width: "100%" }}>
        <h2 className="mb-1">Editar publicación</h2>
        <EditorPublicacion
          evento={evento}
          eventoId={eventoId}
          valoresIniciales={valores}
          esNueva={false}
          onSubmit={guardar}
          textoSubmit="Guardar cambios"
        >
          <Button onClick={() => history.push(`/eventos/${eventoId}/publicaciones`)}>Volver</Button>
        </EditorPublicacion>
      </div>
    </div>
  );
};

export default EditPublicacion;
